module.exports = __webpack_public_path__ + "static/img/tixbay-base-btn.b5b5e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/tixbay-base-btn.png
// module id = 2031
// module chunks = 148